import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import '../../../css/TFR/TerminalRequestService.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import downloadImg from '../../../Assets/TerminalHandling/download.svg';
import uploadImg from '../../../Assets/TerminalHandling/upload.svg';
import uploadDisableImg from '../../../Assets/TerminalHandling/upload-disabled.svg';
import TerminalSuccessModal from '../../Shared/TerminalSuccessModal';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import Message from '../../../Data/Shared/Message.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL, utilityBaseURL, serviceBaseURL } from '../../../Services/config/apiGateway';
import { PROFILE_ENDPOINT, DOCUMENT_ENDPOINT, TFR_SERVICE_ENDPOINT, LOOKUP_ENDPOINT } from '../../../Services/config/apiEndPoints';
import DownloadFile from '../../../Services/utils/DownloadFile';
import { useSelector } from 'react-redux';
import { AES, enc } from 'crypto-js';
import { successLoader, } from '../../../Redux/_actions/loader.action';
import Cookies from 'cookies-js';
import { store } from '../../../Redux/_helpers/store';
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
toast.configure();

const TerminalCreateRequest = props => {
    let history = useHistory();
    const manageProfileDataR = useSelector(state => state.manageProfileReducer.data);
    const userProfileDataR = useSelector(state => JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
    const [terminalRequestData, setTerminalRequestData] = useState([]);
    const [address, setAddress] = useState('');
    const [hasOpenSuccess, setHasOpenSuccess] = useState(false);
    const [filePathTFR, setFilePathTFR] = useState('');
    const [uploadDisable, setUploadDisable] = useState(false);
    let [fileUpload1Error, setFileUpload1Error] = useState();
    let CheckVerifyFileType;

    const documentURL = utilityBaseURL + DOCUMENT_ENDPOINT + "?documentPath=";
    const getRequestData = () => {
        ApiCall(
            'GET',
            baseURL + PROFILE_ENDPOINT + `?userName=${userProfileDataR?.userEmail}`,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    setTerminalRequestData(data);
                    setAddress(data?.address[0]?.addressline1 + ' ' + data?.address[0]?.addressline2);
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }

    useEffect(() => {
        getRequestData();
    }, []);

    const templateDownload = (path) => {
        //start loader
        store.dispatch(successLoader(false));
        const testAccess = Cookies.get('_msAL');
        fetch(documentURL + path, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer' + ` ${testAccess}`,
                'x-cc-trace-id': "123"
            }
        })
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;

                let ext = path.split('.');
                ext = ext[ext.length - 1].split("'")
                ext = ext[0];

                a.download = `TFR.${ext}`;
                document.body.appendChild(a);
                a.click();
                //end loader
                store.dispatch(successLoader(true));
                window.URL.revokeObjectURL(url);
            })
            .catch(() => console.log('error'));
    }

    const downloadDocument = () => {

        ApiCall(
            'GET',

            utilityBaseURL + LOOKUP_ENDPOINT + `?lookupType=TFR_TEMPLATE_URL`,

            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    const templateFilePath = data[0]?.lookupCode;
                    console.log('files--', templateFilePath);
                      DownloadFile( templateFilePath,"TFR");
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }

    const handleSubmitRequest = () => {
        if (validateFunction()) {
            ApiCall(
                'POST',
                serviceBaseURL + TFR_SERVICE_ENDPOINT,
                {
                    "requestId": 0,
                    "responseData": {
                        "businessAddress": "",
                        "companyName": terminalRequestData?.companyDetails?.companyName,
                        "companyRegNbr": terminalRequestData?.companyDetails?.registrationNumber,
                        "dateTime": 0,
                        "filePath": filePathTFR,
                        "postalAddress": address,
                        "status": "Mail Sent",
                        "telephone": terminalRequestData?.userdetails?.user?.userMobile,
                        "vatNbr": terminalRequestData?.companyDetails?.vatNumber
                    }
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == '500') {
                        console.log('I am 500!');


                    } else {
                        console.log('I am 200!');
                        setHasOpenSuccess(true);
                    }
                }

                else {
                    console.log('Something went wrong!');
                }
            });
        }
        if (!validateFunction() && fileUpload1Error) {
            toast("Please upload file before submitting request.", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } });
        }
    }

    const onCloseModal = () => {
        setHasOpenSuccess(false);
        history.push("/RailQuotationHistory");
    };


    const uploadFileFunTFR = (uploadConfirm) => {
        setFileUpload1Error("");
    }
    const setUploadLinkTFR = (filePathURL) => {
        setFilePathTFR(filePathURL);
    }
    function anchorClick(e) {
        e.preventDefault();
        document.querySelector("#TerminalCreateRequestCancelRequest").click();
    }

    const uploadRequest = () => {
        let uploadDisableValue = uploadDisable;
        window.$(function () {
            var fileupload = document.getElementById("TerminalCreateRequestCancelRequest");
            fileupload.onchange = function (e) {
                CheckVerifyFileType = fileupload.value.match(/doc$/) || fileupload.value.match(/Doc$/) || fileupload.value.match(/DOC$/) || fileupload.value.match(/docx$/) || fileupload.value.match(/docX$/) || fileupload.value.match(/DOCX$/) || fileupload.value.match(/DocX$/)

                let files = e.target.files[0];
                if (CheckVerifyFileType) {
                    if (fileupload.files?.length > 0) {
                        for (let i = 0; i <= fileupload.files?.length - 1; i++) {
                            const fsize = fileupload.files.item(i).size;
                            const file = Math.round((fsize / 1024));
                            if (file > 2048) {
                                toast("File too big, please select a file less than 2 MB.", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } });
                            }
                            else {
                                const reader = new window.FileReader();
                                reader.readAsDataURL(files);
                                reader.onload = (f) => {
                                    const formData1 = new window.FormData();
                                    formData1.append('file', files);
                                    console.log("before api call", formData1);
                                    ApiCall(
                                        'POST',
                                        utilityBaseURL +
                                        DOCUMENT_ENDPOINT,
                                        formData1,

                                        {
                                            Accept: 'application/json',
                                            'x-cc-trace-id': '1234',
                                        },
                                        true,
                                        true
                                    ).then((response) => response)
                                        .then((data) => {
                                            if (data.flag != -1) {
                                                console.log('I am 200!');
                                                toast("File uploaded sucessfully.", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } });
                                                uploadDisableValue = true;
                                                setUploadDisable(uploadDisableValue);
                                                setFileUpload1Error("");
                                                uploadFileFunTFR(true);
                                                setUploadLinkTFR(data.documentPath);
                                            } else {
                                                console.log('Something went wrong!');    
                                            }
                                        });
                                }
                            }
                        }
                    }
                }
                else {
                    toast("File should be doc or docx.", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } });
                }
            };
        });
    }

    const validateFunction = () => {
        let isValid = true;
        if (!uploadDisable) {
            isValid = false;
            fileUpload1Error = Message.validation.required;
        } else {
            fileUpload1Error = "";
        }
        setFileUpload1Error(fileUpload1Error);
        return isValid;
    }

    return (
        <div class="csoutercolor">
            <MetaDecorator title={TitleDescription.TFRCreateRequestTitle} description={TitleDescription.TFRCreateRequestDescription} />
            <Header tilesFetched={() => { }} />
            <div class="csnofullTerminalCreateRequest">
                <div id="csnobox1TerminalCreateRequest">
                    <nav class="TerminalCreateRequestNavBar">
                        <div className="TerminalCreateRequestNavBarHeading">
                            <small id="TerminalCreateRequestNavBarHeadingValue">Request Service</small>
                        </div>
                        <div id="TerminalCreateRequestAcceptMobile" className="TerminalCreateRequestNavbarNameRight">
                        <img src={downloadImg} class=" mr-1 pb-1" id="TerminalCreateRequestNavBarRightHeadingImg" alt="" loading="lazy" />
                            <a id="TerminalCreateRequestDownload" class="" onClick={() => downloadDocument()}>Download</a>
                            <a><img src={uploadDisable ? uploadDisableImg : uploadImg} class=" mr-1 pb-1" id="TerminalCreateRequestNavBarRightHeadingImg" alt="" loading="lazy" />
                                <input id="TerminalCreateRequestCancelRequest" disabled={uploadDisable} type="file" onClick={uploadRequest} />
                                <Link to="#" style={{ color: uploadDisable ? "#C4C4C4" : "#d42e12", cursor: uploadDisable ? "default" : "pointer" }}
                                    class="UploadRedCss" onClick={anchorClick}
                                >Upload File</Link>
                            </a>
                        </div>
                    </nav>
                    <hr class="hr1" />
                    <>
                        <nav class="TerminalCreateRequestMobileNavbar">
                            <div className="TerminalCreateRequestNavbarNameRight">
                            <img src={downloadImg} class=" mr-1 pb-1" id="TerminalCreateRequestNavBarRightHeadingImg" alt="" loading="lazy" />
                            <a id="TerminalCreateRequestDownload" class="" onClick={() => downloadDocument()}>Download</a>
                            <a><img src={uploadDisable ? uploadDisableImg : uploadImg} class=" mr-1 pb-1" id="TerminalCreateRequestNavBarRightHeadingImg" alt="" loading="lazy" />
                                <input id="TerminalCreateRequestCancelRequest" disabled={uploadDisable} type="file" onClick={uploadRequest} />
                                <Link to="#" style={{ color: uploadDisable ? "#C4C4C4" : "#d42e12", cursor: uploadDisable ? "default" : "pointer" }}
                                    class="UploadRedCss" onClick={anchorClick}
                                >Upload File</Link>
                            </a>
                            </div>
                        </nav> 
                        <hr class="hrTRSMobile" />
                    </>
                    <div class="toppartTerminalCreateRequest">
                        <div class="TerminalCreateRequestFirstNoteDiv">
                            <small class="TerminalCreateRequestFirstNote">To complete the request please download the template, fill the details and upload again</small>
                        </div>
                        <div class="TerminalCreateRequestSecondHeadingDiv">
                            <small class="TerminalCreateRequestSecondHeading">Customer Details</small>
                        </div>
                        <div class="toppartTerminalCreateRequestOuterBox">
                            <div class="toppartTerminalCreateRequestWholeInnerBox">

                                <div class="TerminalCreateRequestContentsDiv">
                                    <small class="TerminalCreateRequestHeadings">Name of Company</small>
                                    <small class="TerminalCreateRequestValue">{terminalRequestData?.companyDetails?.companyName}</small>
                                </div>
                                {manageProfileDataR?.selectedProfileType === "Requester" &&
                                    <div class="TerminalCreateRequestContentsDiv">
                                        <small class="TerminalCreateRequestHeadings">Company Registration Number</small>
                                        <small class="TerminalCreateRequestValue">{terminalRequestData?.companyDetails?.registrationNumber}</small>
                                    </div>
                                }
                                {manageProfileDataR?.selectedProfileType === "Requester" &&
                                    <div class="TerminalCreateRequestContentsDiv">
                                        <small class="TerminalCreateRequestHeadings">VAT Number</small>
                                        <small class="TerminalCreateRequestValue">{terminalRequestData?.companyDetails?.vatNumber}</small>
                                    </div>
                                }
                                <div class="TerminalCreateRequestContentsDiv">
                                    <small class="TerminalCreateRequestHeadings">Telephone Number</small>
                                    {terminalRequestData?.userdetails?.user?.userMobile != 0
                                        ?
                                        <small class="TerminalCreateRequestValue">
                                            {terminalRequestData?.userdetails?.user?.userMobile}</small>
                                        :
                                        <small class="TerminalCreateRequestValueMobile">
                                            Not available</small>
                                    }
                                </div>
                                {manageProfileDataR?.selectedProfileType === "Requester" &&
                                    <>
                                        <div class="TerminalCreateRequestContentsDiv">
                                            <small class="TerminalCreateRequestHeadings">Business Address</small>
                                            <small class="TerminalCreateRequestValue">{}</small>
                                        </div>

                                        <div class="TerminalCreateRequestContentsDiv">
                                            <small class="TerminalCreateRequestHeadings">Postal Address</small>
                                            <small class="TerminalCreateRequestValue">{address}</small>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        <div class="TerminalCreateRequestButtonDiv">
                            <Button class="TerminalCreateRequestButton" onClick={handleSubmitRequest}>
                                <small class="TerminalCreateRequestButtonText" >Submit Request</small>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cs2footer11TerminalCreateRequest">
                <Footer />
            </div>
            <div class="cs2footer22TerminalCreateRequest">
                <Footer2 />
            </div>
            <TerminalSuccessModal hasOpen={hasOpenSuccess} onCloseModal={onCloseModal}>
                <div>
                    <div class="TerminalSuccessDivOut">
                        <div class="TerminalSuccessSmupdiv">
                            <small class="TerminalSuccessSmupbold">{Message.TFR.terminalSuccessModalQueryNote}</small>
                        </div>
                        <div class="TerminalSuccessLowerNoteDiv">
                            <small class="TerminalSuccessLowerNote">{Message.TFR.terminalSuccessModalNote}<small class="TerminalSuccessLowerNoteRed">Transnet.CNC@transnet.net</small></small>
                        </div>
                    </div>
                </div>
            </TerminalSuccessModal>
        </div>
    );
};

export default TerminalCreateRequest;